import { Star, Quote } from "lucide-react";

const items = [
  {
    text: "En 4 mois, on est passés du mode pompier au mode pilote. Mes équipes savent ce qu'elles font le lundi matin. Et moi je dors la nuit.",
    name: "Marc D.",
    role: "Dirigeant — PME industrie",
  },
  {
    text: "L'approche neuro a tout changé. On avait essayé deux cabinets avant. Là, le changement tient parce qu'il est ancré dans la tête des gens, pas dans un PowerPoint.",
    name: "Stéphanie R.",
    role: "DRH — Groupe distribution",
  },
  {
    text: "Les automatisations IA que ShinRai a déployées m'économisent 14 heures par semaine. Le ROI était sous les 4 mois. Concret, vérifiable.",
    name: "Karim B.",
    role: "Directeur opérations — Logistique",
  },
];

export default function TestimonialsSection() {
  return (
    <section className="bg-pearl py-24 sm:py-32" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <div className="mb-16 max-w-3xl">
          <div className="font-mono-overline text-mute mb-3">Ils témoignent</div>
          <h2 className="font-serif text-4xl sm:text-5xl leading-[1.05] tracking-tight">
            Ce que disent les dirigeants <em className="text-mute not-italic font-light">qui ont franchi le pas.</em>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {items.map((t, i) => (
            <figure
              key={t.name}
              className="bg-pearl-dark p-8 sm:p-10 card-lift border-l-2 border-gold/40 relative"
              data-testid={`testimonial-card-${i + 1}`}
            >
              <Quote size={28} className="text-ink/15 absolute top-6 right-6" />
              <div className="flex gap-0.5 mb-5">
                {[...Array(5)].map((_, j) => (
                  <Star key={j} size={14} className="text-gold" fill="currentColor" />
                ))}
              </div>
              <blockquote className="font-serif text-xl leading-snug text-ink mb-8">
                « {t.text} »
              </blockquote>
              <figcaption className="text-sm">
                <div className="font-semibold text-ink">{t.name}</div>
                <div className="text-mute text-xs mt-0.5">{t.role}</div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
